/*
 * WHICH RUN A SPAWN CALL STARTED, read off the call's own outcome.
 *
 * A module of its own because two layers need it and must not import each other: the manager
 * follows a spawned tree from it, and the turn renderer asks the host about that run's state from
 * it — and the renderer is deliberately below the manager in the import graph.
 */
/** The run the spawn started, or '' when the outcome carries none. */
export function spawnedRunIdOfTool(data) {
    const out = data;
    const id = out?.data?.runId ?? out?.runId;
    return typeof id === 'string' ? id : '';
}
/** The root of the tree that run belongs to, or '' when the outcome carries none. */
export function rootRunIdOfTool(data) {
    const out = data;
    const root = out?.data?.rootRunId ?? out?.rootRunId;
    return typeof root === 'string' ? root : '';
}
//# sourceMappingURL=spawn-ids.js.map